import { FC } from 'react';
import { Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';
import HardwareCompatibilityField from './HardwareCompatibilityField';

export const SoftwareComponentShow: FC<ShowProps> = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="path" emptyText="-" />
      <TextField source="build_project_name" emptyText="-" />
      <HardwareCompatibilityField label="resources.software_components.fields.hardware_ids" />
    </SimpleShowLayout>
  </Show>
);
